/** Read `?passageId=` from the current page URL for deep-linking between editor steps. */
export function passageIdFromLocationSearch() {
  if (typeof window === 'undefined') return '';
  try {
    const raw = new URLSearchParams(window.location.search).get('passageId');
    if (raw == null || String(raw).trim() === '') return '';
    const t = String(raw).trim();
    if (!/^\d+$/.test(t)) return '';
    return String(parseInt(t, 10));
  } catch {
    return '';
  }
}
